import React from "react";
import aboutImage from "../../images/SeattleByBike-TourLeaderColin.jpg";

const About = () => (
  <div className="w-5/6 max-w-xl ml-auto mr-auto bg-brand-white my-8 px-6 py-8 mx-auto" id="about"  data-aos="fade" data-aos-duration="1200" data-aos-delay="300" data-aos-once="true">
    <div className="flex items-center justify-center mx-auto">
      <img src={aboutImage} className="rounded w-full" alt="Photo showing the Tour Guide Leader Colin leading a bike tour at the Ballard Locks."></img>
    </div>
    <p className="font-bold mt-8 mb-2 font-title">About Seattle By Bike
    </p>

    <p className="leading-normal font-body">
    Seattle by Bike is a partnership of local bike enthusiasts with skills in various areas - education, graphic design, and web development. Our goal is to create a simple, enjoyable, experience of seeing Seattle at the speed of a bike ride. We think it is the best way to learn about and appreciate our city!
    </p>

    <div className="flex items-center justify-center py-8">
      <button className="flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-500 fb-entity-config-id- fb-domain-go.theflybook.com fb-protocol-https rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide">Book Now
      </button>
    </div>
    
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About/index.js